import React from 'react';
import { ApiKeySection } from './ApiKeySection';
import { ResourceUsageSection } from './ResourceUsageSection';
import { DangerZone } from './DangerZone';
interface Props {
  spaceId: string;
}
// Update mock settings data to match expected structure
const mockSettingsData = {
  apiKey: 'sk-test-123456789',
  usage: {
    storage: {
      used: 2.4,
      total: 5,
      unit: 'GB'
    },
    documents: {
      count: 145,
      limit: 200
    },
    chatbots: {
      count: 3,
      limit: 10
    },
    users: {
      count: 12,
      limit: 20
    }
  }
};
export const SettingsTab = ({
  spaceId
}: Props) => {
  return <div className="space-y-8" data-id="element-1342">
      <div data-id="element-1343">
        <h2 className="text-xl font-medium text-white font-mono" data-id="element-1344">Settings</h2>
        <p className="text-sm text-gray-400 mt-1" data-id="element-1345">
          Manage your Knowledge Space configuration and resources
        </p>
      </div>
      <div className="space-y-6" data-id="element-1346">
        <ApiKeySection apiKey={mockSettingsData.apiKey} data-id="element-1347" />
        <ResourceUsageSection usage={mockSettingsData.usage} data-id="element-1348" />
        <DangerZone spaceId={spaceId} data-id="element-1349" />
      </div>
    </div>;
};